import { styled } from '@ori-ui/mui';
import { useIsMobile } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';
import React from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';

const StyledVideo = styled('video')(() => ({
  height: '100%',
  left: 0,
  objectFit: 'cover',
  objectPosition: '50% 50%',
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 2,
}));

export const BannerVideo: FC = () => {
  const { getTestId } = useTestId();
  const isMobile = useIsMobile();

  const { backgroundVideoUrl } = useTopAreaStore();

  if (!backgroundVideoUrl || isMobile) {
    return null;
  }

  return (
    <StyledVideo
      autoPlay
      loop
      muted
      controls={false}
      data-testid={getTestId('video')}
      src={backgroundVideoUrl}
    />
  );
};
